<template>
  <nav id="RTE__toolbar">
    <v-toolbar height="auto">
      <v-toolbar-items>
        <bold @click="onClick" class="RTE__rich__text__button" v-if="display.bold"/>
        <italic @click="onClick" class="RTE__rich__text__button" v-if="display.italic"/>
        <underline @click="onClick" class="RTE__rich__text__button" v-if="display.underline"/>
        <removeFormat @click="onClick" class="RTE__rich__text__button" v-if="display.removeFormat"/>
        <orderedList @click="onClick" class="RTE__rich__text__button" v-if="display.orderedList"/>
        <unorderedList @click="onClick" class="RTE__rich__text__button" v-if="display.unorderedList"/>
        <linkButton @click="onClick" class="RTE__rich__text__button" v-if="display.linkButton"/>
        <imageButton @click="onClick" class="RTE__rich__text__button" v-if="display.imageButton"/>
        <undo @click="onClick" class="RTE__rich__text__button" v-if="display.undo"/>
        <redo @click="onClick" class="RTE__rich__text__button" v-if="display.redo"/>
      </v-toolbar-items>
    </v-toolbar>

    <v-dialog v-model="link.displayDialog" width="500">
      <v-card>
        <v-card-title>
          <span class="RTE__headline">Ajouter un lien</span>
        </v-card-title>
        <v-card-text>
          <v-text-field label="Texte du lien" v-model="link.text"/>
          <v-text-field label="URL du lien" v-model="link.url"/>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn text @click="addLink">Ajouter</v-btn>
          <v-btn text @click="link.displayDialog = false">Annuler</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="image.displayDialog" width="500">
      <v-card>
        <v-card-title>
          <span class="RTE__headline">Ajouter une image</span>
        </v-card-title>
        <v-card-text>
          <v-text-field label="URL de l'image" v-model="image.url"/>
          <v-text-field label="Texte alternatif de l'image" v-model="image.alternativeText"/>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn text @click="addImage">Ajouter</v-btn>
          <v-btn text @click="image.displayDialog = false">Annuler</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </nav>
</template>

<script>
import bold from './buttons/bold'
import italic from './buttons/italic'
import underline from './buttons/underline'
import removeFormat from './buttons/removeFormat'
import orderedList from './buttons/orderedList'
import unorderedList from './buttons/unorderedList'
import linkButton from './buttons/linkButton'
import imageButton from './buttons/imageButton'
import undo from './buttons/undo'
import redo from './buttons/redo'

export default {
  name: 'toolbar',
  components: {
    bold,
    italic,
    underline,
    removeFormat,
    orderedList,
    unorderedList,
    linkButton,
    imageButton,
    undo,
    redo
  },
  props: {
    buttonsDisplay: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      link: {
        displayDialog: false,
        text: '',
        url: ''
      },
      image: {
        displayDialog: false,
        alternativeText: '',
        url: ''
      },
      selection: {
        selectionObject: null,
        range: null
      },
      display: {}
    }
  },
  created () {
    this.display = {
      bold: true,
      italic: true,
      underline: true,
      removeFormat: true,
      orderedList: true,
      unorderedList: true,
      linkButton: true,
      imageButton: true,
      undo: true,
      redo: true,
      ...this.buttonsDisplay
    }
  },
  methods: {
    addImage () {
      this.image.displayDialog = false

      let imageElement = document.createElement('img')
      imageElement.src = this.image.url
      imageElement.alt = this.image.alternativeText

      this.selection.selectionObject.extend(this.selection.range.startContainer, this.selection.range.startOffset)
      this.selection.selectionObject.collapseToEnd()
      this.selection.range.insertNode(imageElement)
    },
    addLink () {
      this.link.displayDialog = false

      let linkElement = document.createElement('a')
      linkElement.href = this.link.url
      linkElement.text = this.link.text
      linkElement.target = '_blank'

      this.selection.selectionObject.extend(this.selection.range.startContainer, this.selection.range.startOffset)
      this.selection.selectionObject.collapseToEnd()
      this.selection.range.insertNode(linkElement)
    },
    onClick (event) {
      if (event === 'createLink' || event === 'addImage') {
        this.selection.selectionObject = document.getSelection()
        this.selection.range = this.selection.selectionObject.getRangeAt(0)

        event === 'createLink' ? this.link.displayDialog = true : this.image.displayDialog = true
      } else {
        document.execCommand(event, false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  #RTE__toolbar {
    width: 100%;

    .v-toolbar__items {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      width: 100%;

      > .v-btn {
        height: 40px !important;
      }
    }
  }
</style>
